import React from "react";
import s from "./style.module.css";
import ContentCard from "../ContentCard";

const SpotlightsList = ({ items = [] }) => {
  return (
    <div className={s.spotlights}>
      {items.map(({ path, tag, title, content }) => (
        <ContentCard
          key={path}
          alternate
          icon={
            <img
              className={s.icon}
              src={`/images/spotlights/icons/${tag}.svg`}
              alt=""
            />
          }
          to={path}
          title={tag}
          description={title}
        />
      ))}
    </div>
  );
};

export default SpotlightsList;
